import { useCallback, useEffect, useState } from "react";
import dayjs, { Dayjs } from "dayjs";

import { Box, Stack, Typography, CardMedia, IconButton, Pagination, Paper, Button, PaginationItem } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import {
  DataGrid,
  GridCellParams,
  GridColDef,
  useGridApiRef,
  useGridSelector,
  gridPageSelector,
  gridPageCountSelector,
  GridRowSelectionModel,
  GridPaginationModel,
  GridRenderCellParams,
} from "@mui/x-data-grid";

// Components
import { userState } from "../../interface/MainInterface";
import { HttpUnAuthApi } from "../../interface/unauth-api";
import { useWindowSize } from "../../utils/useWindowSize";

// CSS
import "./ReportList.css";
import "swiper/css";
import { useNavigate } from "react-router-dom";
import { report } from "process";

interface propsType {
  userState: userState;
}

const unAuthAPI = new HttpUnAuthApi();

const ReportList = (props: propsType) => {
  const windowSize = useWindowSize();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [srchDateFrom, setSrchDateFrom] = useState<Dayjs | null>(dayjs().subtract(90, "day"));
  const [srchDateTo, setSrchDateTo] = useState<Dayjs | null>(dayjs().add(7, "day"));

  const gridApi = useGridApiRef();
  const [gridHeight, setGridHeight] = useState<any>(null);
  const [pageSize, setPageSize] = useState<any>(null);
  const [selectedRow, setSelectedRow] = useState<GridRowSelectionModel>([]);
  const [selectedPage, setSelectedPage] = useState<GridPaginationModel | null>(null);

  const [reportList, setReportList] = useState<any>([]);
  const [selectedReports, setSelectedReports] = useState<any>([]);

  useEffect(() => {
    if (!props.userState.isAuth) window.location.href = "/";
    return () => {
      setIsLoading(false);
      setSrchDateFrom(null);
      setSrchDateTo(null);
      setGridHeight(null);
      setPageSize(null);
      setSelectedRow([]);
      setSelectedPage(null);
      setReportList([]);
      setSelectedReports([]);
    };
  }, []);

  const columns: GridColDef[] = [
    {
      field: "pk",
      headerName: "",
      width: 80,
      headerAlign: "center",
      align: "center",
      headerClassName: "grid-header",
      renderCell: (param: GridRenderCellParams) => {
        return (
          <div className="gird-checkbox-wrap">
            <input
              type="checkbox"
              id={`checkBrief${param.row.sk}`}
              className="report-check-brief"
              onClick={() => {
                selectReport(param.row.sk);
                // props.callback({ command: "selectBrief", key: `${props.briefInfo.pk}/${props.briefInfo.sk}` });
              }}
              onChange={(e) => {}}
              checked={selectedReports.indexOf(param.row.sk) > -1}
            />
            <label htmlFor={`checkBrief${param.row.sk}`}></label>
          </div>
        );
      },
    },
    {
      field: "report_title",
      headerName: "제목",
      flex: 1,
      headerAlign: "center",
      align: "left",
      headerClassName: "grid-header",
      renderCell: (param: GridRenderCellParams) => {
        return (
          <Stack direction="column" sx={{ cursor: "pointer", width: "100%", overflow: "hidden" }} >
            <Typography sx={{ fontSize: "17px", fontWeight: "700", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{param.row.report_title}</Typography>
            <Stack direction="row" gap={1} sx={{ display: "flex", alignItems: "center" }}>
              <CardMedia component={"img"} image="/images/icon-keyword.png" sx={{ width: "14px", height: "14px" }} />
              <Typography sx={{ fontSize: "14px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{param.row.report_keyword && param.row.report_keyword.join(", ")}</Typography>
            </Stack>
          </Stack>
        );
      },
    },
    {
      field: "발행일자",
      width: 220,
      headerAlign: "center",
      align: "center",
      headerClassName: "grid-header",
      renderCell: (param: GridRenderCellParams) => {
        return (
          <>
            <Typography sx={{ fontWeight: "400", fontSize: "14px", color: "rgba(138, 138, 138, 1)" }}>
              {param.row.report_status === "COMPLETE" ? dayjs(param.row.sk).format("YYYY-MM-DD") + " 발행" : "레포트 생성중..."}
            </Typography>
          </>
        );
      },
    },
  ];

  const columnsMobile: GridColDef[] = [
    {
      field: "pk",
      headerName: "",
      width: 80,
      headerAlign: "center",
      align: "center",
      headerClassName: "grid-header",
      renderCell: (param: GridRenderCellParams) => {
        return (
          <div className="gird-checkbox-wrap">
            <input
              type="checkbox"
              id={`checkBrief${param.row.sk}`}
              className="report-check-brief"
              onClick={() => {
                selectReport(param.row.sk);
                // props.callback({ command: "selectBrief", key: `${props.briefInfo.pk}/${props.briefInfo.sk}` });
              }}
              onChange={(e) => {}}
              checked={selectedReports.indexOf(param.row.sk) > -1}
            />
            <label htmlFor={`checkBrief${param.row.sk}`}></label>
          </div>
        );
      },
    },
    {
      field: "report_title",
      headerName: "제목",
      flex: 1,
      // width: 250,
      headerAlign: "center",
      align: "left",
      headerClassName: "grid-header",
      renderCell: (param: GridRenderCellParams) => {
        return (
          <Stack direction="column" sx={{ cursor: "pointer", width: "100%", overflow: "hidden" }} >
            <Typography sx={{ fontSize: "17px", fontWeight: "700", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{param.row.report_title}</Typography>
            <Stack direction="row" gap={1} sx={{ display: "flex", alignItems: "center" }}>
              <CardMedia component={"img"} image="/images/icon-keyword.png" sx={{ width: "14px", height: "14px" }} />
              <Typography sx={{ fontSize: "14px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{param.row.report_keyword && param.row.report_keyword.join(", ")}</Typography>
            </Stack>
            <Typography sx={{ fontWeight: "400", color: "rgba(138, 138, 138, 1)", marginTop: "16px", width: "100%", boxSizing: "border-box" }}>
              {param.row.report_status === "COMPLETE" ? dayjs(param.row.sk).format("YYYY-MM-DD") + " 발행" : "레포트 생성중..."}
            </Typography>
          </Stack>
        );
      },
    },
    {
      field: "fake_width",
      headerName: "빈칸",
      width: 60,
      headerAlign: "center",
      align: "center",
      headerClassName: "grid-header",
      renderCell: (param: GridRenderCellParams) => {
        return (
          <div>
          </div>
        )
      }
    }
  ];

  function CustomPagination() {
    const page = useGridSelector(gridApi, gridPageSelector);
    const pageCount = useGridSelector(gridApi, gridPageCountSelector);
    return (
      <Box sx={{ display: "flex", width: "100%", justifyContent: "center" }}>
        <Pagination
          color="primary"
          shape="rounded"
          count={pageCount === 0 ? 1 : pageCount}
          page={page + 1}
          siblingCount={10}
          onChange={(e, v) => gridApi.current.setPage(v - 1)}
          renderItem={(item) => (
            <PaginationItem
              {...item}
              // next 버튼을 커스터마이즈
              components={{
                previous: (props) => (
                  <Stack direction="row" gap={2}>
                    <Typography sx={{ fontWeight: 500, fontSize: "13px", color: '#2A2A2A' }}>이전</Typography>
                    <img src="images/btn-ghost-prev.png" alt="Prev" {...props} />
                  </Stack>
                ),
                next: (props) => (
                  <Stack direction="row" gap={2}>
                    <img src="images/btn-ghost-next.png" alt="Next" {...props} />
                    <Typography sx={{ fontWeight: 500, fontSize: "13px", color: '#2A2A2A' }}>다음</Typography>
                  </Stack>
                ),
              }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                textAlign: 'center',
                textDecorationLine: item.selected ? 'underline' : 'none',
                color: item.selected ? '#2A2A2A' : '#B1B1B1',
                userSelect: 'none',
                backgroundColor: 'transparent', // 배경 투명
                border: 'none', // 테두리 없음
                boxShadow: 'none', // 그림자 없음
                fontWeight: 500,
                minWidth: "23px",
                '&:hover': {
                  backgroundColor: 'transparent', // 호버 시 배경 투명
                },
                '&.Mui-selected': {
                  backgroundColor: 'transparent', // 선택된 상태 배경 제거
                  color: '#2A2A2A', // 선택된 상태 색상
                },
              }}
            />
          )}
        ></Pagination>
      </Box>
    );
  }

  const evtGridClick = useCallback(
    (param: GridCellParams) => {
      if (param.field === "report_title" && param.row.report_status === "COMPLETE") {
        navigate(`/report/${param.row.sk}`);
      }
    },
    [navigate]
  );

  const selectReport = (_sk: string) => {
    let temp: any = [...selectedReports];
    const idx = temp.indexOf(_sk);
    if (idx > -1) {
      temp.splice(idx, 1);
    } else {
      temp.push(_sk);
    }
    setSelectedReports(temp);
  };

  const get_report_list = async () => {
    const param: any = {
      command: "get_my_report_list",
      user_id: props.userState.id,
      from_dtm: dayjs(srchDateFrom).format("YYYYMMDD"),
      to_dtm: dayjs(srchDateTo).add(1, "day").format("YYYYMMDD"),
      sort: "DESCEND",
    };

    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      setReportList(res.response.report_list);
    }
  };

  useEffect(() => {
    get_report_list();
  }, [srchDateFrom, srchDateTo]);

  // 페이지 당 행 수 지정 
  const getPageSize = (isMobile: boolean, listLength: number) => {
    return Math.min(isMobile ? 5 : 10, listLength);
  }
  
  // 행 높이 지정
  const getRowHeight = (isMobile: boolean) => {
    return isMobile ? 121 + 16 : 87 + 16
  }

  useEffect(() => {
    const isMobile = windowSize.width <= 1023;
    const pSize = getPageSize(isMobile, reportList.length);

    setPageSize(pSize);
    setSelectedPage({ pageSize: pSize, page: 0 });
    // setGridHeight(gHeight);
  }, [windowSize, reportList.length]);

  useEffect(() => {
    const isMobile = windowSize.width <= 1023;
    const rowHeight = getRowHeight(isMobile);

    if (selectedPage) {
      const totalPages = Math.ceil(reportList.length / pageSize);
      const isLastPage = (selectedPage.page + 1) >= totalPages;

      let currentPageDataCount = 0;

      if (isLastPage) {
        const remainingData = reportList.length % pageSize;
        currentPageDataCount = remainingData === 0 ? pageSize : remainingData;
      } else {
        currentPageDataCount = pageSize;
      }

      const gHeight = currentPageDataCount * rowHeight + 16 + 60 + 20;
      setGridHeight(gHeight);
    }
    
  }, [selectedPage]);

  const delete_report_list = async () => {
    if (selectedReports.length < 1) return;

    // 먼저 confirm을 처리하고, 이후에 비동기 코드 실행 (iOS 18.6.2 버전에서 동작하지 않아서 confirmed 처리)
    const confirmed = window.confirm("선택한 리포트를 삭제하시겠습니까?\n삭제한 데이터는 복구할 수 없습니다.");
    if (!confirmed) return;
    
    setIsLoading(true);
    for (const deleteKey of selectedReports) {
      const param: any = {
        command: "delete_report_info",
        report_key: deleteKey,
      };

      const res = await unAuthAPI.post(param);
    }

    setIsLoading(false);

    get_report_list();
  };

  return (
    <>
      <section id="commWrap" className="report-list">
        <article className="article-01">
          <div className="article-tit ta-c">{"내가 발행한 리포트를 확인하세요"}</div>
        </article>
        <Box
          sx={{
            display: "flex",
            flexDirection: windowSize.width > 1023 ? "row" : "column",
            justifyContent: "space-between",
            gap: "24px",
            margin: "0 10px",
          }}
        >
          <Box sx={{ width: windowSize.width > 1023 ? "400px" : "100%" }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack direction={"row"} spacing={2}>
                <DatePicker
                  showDaysOutsideCurrentMonth
                  format="YYYY-MM-DD"
                  value={srchDateFrom}
                  onChange={(newValue) => setSrchDateFrom(newValue)}
                  slotProps={{
                    textField: {
                      size: "small",
                      InputProps: {
                        style: {
                          borderRadius: "20px",
                        },
                      },
                    },
                  }}
                />
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography>{" ~ "}</Typography>
                </Box>
                <DatePicker
                  showDaysOutsideCurrentMonth
                  format="YYYY-MM-DD"
                  value={srchDateTo}
                  onChange={(newValue) => setSrchDateTo(newValue)}
                  slotProps={{
                    textField: {
                      size: "small",
                      InputProps: {
                        style: {
                          borderRadius: "20px",
                        },
                      },
                    },
                  }}
                />
              </Stack>
            </LocalizationProvider>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            {!isLoading && (
              <IconButton sx={{ p: 0 }} onClick={delete_report_list}>
                <CardMedia component={"img"} image="/images/btn-delete-circle.png" sx={{ width: "40px", height: "40px" }} />
              </IconButton>
            )}
          </Box>
        </Box>
        {reportList.length > 0 && gridHeight && pageSize && selectedPage && (
          <Box sx={{ width: "100%", height: gridHeight }}>
            <DataGrid
              apiRef={gridApi}
              rows={reportList}
              columns={windowSize.width > 1023 ? columns : columnsMobile}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: pageSize,
                  },
                },
                sorting: {
                  sortModel: [
                    {
                      field: "range_num",
                      sort: "asc",
                    },
                  ],
                },
              }}
              sx={{
                border: "0px",
                "& .MuiDataGrid-columnHeaders": { borderColor: "#fff" },
                "& .MuiDataGrid-footerContainer": { borderColor: "#fff" },
                "& .MuiDataGrid-cell": { borderColor: "rgba(221, 221, 221, 1)", background: "#ffffff", border: 'none', padding: "10px 0px", overflow: "hidden" },
                "& .MuiDataGrid-virtualScroller": { overflow: 'hidden' },
                "& .MuiDataGrid-virtualScrollerContent": { width: "100% !important" },
                "& .MuiDataGrid-virtualScrollerRenderZone": { position: "relative" },
                "& .MuiDataGrid-row.Mui-selected": { backgroundColor: "#ffffff" },
                "& .MuiDataGrid-row.Mui-selected.Mui-hovered": { backgroundColor: "#ffffff" },
                "& .MuiDataGrid-row.Mui-selected.Mui-hover": { backgroundColor: "#ffffff" },
                "& .MuiDataGrid-cell.Mui-hovered": { background: "#ffffff" },
                "& .MuiDataGrid-row.Mui-hover": { background: "#ffffff" },
                "& .MuiDataGrid-row.Mui-hovered": { 
                  background: "#ffffff", 
                  border: '1px solid #2A2A2A', 
                  cursor: 'pointer' 
                },
                "& .Mui-hovered": { backgroundColor: "#ffffff" },
                "& .MuiDataGrid-cell:focus": { outline: "none" },
                '& .MuiDataGrid-row': {
                  boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.1)', // 그림자
                  borderRadius: '20px', // 둥근 모서리
                  marginLeft: '11px',
                  marginRight: '11px',
                  marginTop: '16px', // 행 사이의 간격
                  overflow: "hidden",
                  boxSizing: 'border-box',
                  width: 'inherit',
                  backgroundColor: '#fff', // 배경색
                },
              }}
              slots={{ pagination: CustomPagination }}
              hideFooterSelectedRowCount
              getRowId={(row) => row.sk}
              rowSelectionModel={selectedRow}
              onRowSelectionModelChange={(newRowSelectionModel) => {
                setSelectedRow(newRowSelectionModel);
              }}
              paginationModel={selectedPage}
              onPaginationModelChange={(newPagenationModel) => {
                setSelectedPage(newPagenationModel);
              }}
              onCellClick={evtGridClick}
              rowHeight={windowSize.width > 1023 ? 87 : 121}
              columnHeaderHeight={16}
            />
          </Box>
        )}
        <div className="fake-height-80" />
      </section>
    </>
  );
};

export default ReportList;
